/* global jQuery, dokan_order_min_max */
import OrderMinMaxFormValidation from './../order-min-max-form-validation';

( function ( $ ) {
    $( document ).ready( function () {
        // eslint-disable-next-line camelcase
        const settings = dokan_order_min_max || {};

        $( '#dokan-product-list-table' ).on('click', '.editline a', function () {
                const minMaxMetaData = $( this ).closest( '.row-actions' ).siblings( `.${ settings.constants.QUICK_EDIT_META_DATA }` ).data( 'min-max-data' );
                if ( ! minMaxMetaData ) {
                    return;
                }

                const productId = $( this ).closest( '.row-actions' ).siblings( `.${ settings.constants.QUICK_EDIT_META_DATA }` ).data( 'product-id' );
                const quickEditMinMaxArea = $( `#post-${ productId }.dokan-product-list-inline-edit-form .dokan-min-max-wrapper.dokan-min-max-vendor` );
                const minQuantityField = quickEditMinMaxArea.find( `.${ settings.constants.QUICK_EDIT_MINIMUM_QUANTITY }` );
                const maxQuantityField = quickEditMinMaxArea.find( `.${ settings.constants.QUICK_EDIT_MAXIMUM_QUANTITY }` );

                minQuantityField.val( minMaxMetaData.min_quantity );
                maxQuantityField.val( minMaxMetaData.max_quantity );

                new OrderMinMaxFormValidation( minQuantityField, maxQuantityField );
        });

        $( '#bulk-product-action' ).on( 'click', function () {
            if ( $( '#bulk-product-action-selector' ).val() === 'edit' ) {
                const bulkEditMinMaxSection = $(
                    '#bulk-edit .dokan-min-max-wrapper.dokan-min-max-vendor'
                );
                const minQuantityField = bulkEditMinMaxSection.find(
                    `.${ settings.constants.BULK_EDIT_VENDOR_MINIMUM_QUANTITY }`
                );
                const maxQuantityField = bulkEditMinMaxSection.find(
                    `.${ settings.constants.BULK_EDIT_VENDOR_MAXIMUM_QUANTITY }`
                );

                new OrderMinMaxFormValidation(
                    minQuantityField,
                    maxQuantityField
                );
            }
        } );

        if ( $( '.dokan-product-edit-form' ).length > 0 ) {
            const wrapper = $( `.${ settings.constants.VENDOR_SIMPLE_PRODUCT_METABOX_WRAPPER }` );
            const minQuantityField = wrapper.find( `#${ settings.constants.SIMPLE_PRODUCT_MIN_QUANTITY }` );
            const maxQuantityField = wrapper.find( `#${ settings.constants.SIMPLE_PRODUCT_MAX_QUANTITY }` );

            new OrderMinMaxFormValidation( minQuantityField, maxQuantityField );
        }

        if ( $( '.dokan-attribute-variation-options' ).length > 0 ) {
            $( '.dokan-product-variation-wrapper' ).on( 'click', '.dokan-product-variation-itmes .variation-topbar-heading', function ( e ) {
                const variationMinMaxFieldList = $( e.currentTarget ).parent().find( `.${ settings.constants.VENDOR_VARIATION_PRODUCT_METABOX_WRAPPER }` );
                if( variationMinMaxFieldList.attr( 'data-variation-min-max-loaded' ) === 'true' ) {
                    return;
                }

                // set loaded flag
                variationMinMaxFieldList.attr( 'data-variation-min-max-loaded', 'true' );
                variationMinMaxFieldList.map( ( index, value ) => {
                    const minimumQuantityField = $( value ).find( `.${ settings.constants.VARIATION_PRODUCT_MIN_QUANTITY }` );
                    const maximumQuantityField = $( value ).find( `.${ settings.constants.VARIATION_PRODUCT_MAX_QUANTITY }` );

                    new OrderMinMaxFormValidation( minimumQuantityField, maximumQuantityField );
                } );
            });
        }
    } );
} )( jQuery );
